import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/xbox': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39-27.9-18.2-34.2-25.7-34.2-40.6 0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-66.4 81.5-106 155.4-120.3 194.4-9.8 26.5-13.7 53-9.5 64 2.8 7.4 0.2 4.7-9.3-9.9-23.2-35.5-34.9-70.4-40.5-120.9-1.9-16.7-1.2-26.3 4.2-60.5 6.8-42.7 31.1-92 60.3-122.4 12.4-12.9 13.5-13.2 28.7-8.1 28.3 9.5 56.7 36.5 86.4 63.4zM500.2 207.3c4.7 22.6 5.1 70.9 0.8 93.4-3.6 18.5-11.2 42.5-18.6 58.7-5.5 12.2-19.3 35.8-25.4 43.5-3.1 3.9-3.1 3.9-1.4-4.6 2.3-11.2-0.6-31.6-7.4-52.3-20.7-62.9-80.5-149-122.9-202.3 23.3-21.4 41-38.3 64.3-52.8 11.8-7.4 28.7-13.9 36-13.9 7.1 0 57.7 50.3 74.6 130.3zM141.3 43c-14.6 0.7-14-0.1 9.4-11.2 81.2-38.3 170-27.6 233.9 11.7-13.4-0.6-43.5-5.9-107.4 25.2-11.2 5.5-20.9 9.8-21.6 9.7-4.6-0.9-66.6-37.9-114.3-35.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/xbox.js
// module id = 1102
// module chunks = 0